import type { RfxQuestionType } from "../types/returnable-schedule-question.type";
import {
	HAS_ACCEPTED,
	HAS_SUBMITTED,
	QUESTION_TYPE_ID,
	RFX_SUBMISSION_STATUS,
} from "./constants";
import { generateSaveSubmissionPayload } from "./data-processor";
import {
	acceptDeclineSubmission,
	getAllSubmissions,
	getCompanySubmission,
	getGuestRfxInvitation,
	revokeSubmission,
	saveSubmission,
	submitSubmission,
} from "./submission-api";
import { getTextLengthValue, isSmartField } from "./submission-helpers";
import type { GuestCompanyData } from "./types/guest-company-data.type";
import { ReturnableScheduleFileUpload } from "./types/returnable-schedule-answer.type";
import type { RfxSubmissionStatus } from "./types/submission.type";

const submissionApi = {
	acceptDeclineSubmission,
	getAllSubmissions,
	getCompanySubmission,
	getGuestRfxInvitation,
	revokeSubmission,
	saveSubmission,
	submitSubmission,
};

export type { GuestCompanyData, RfxQuestionType, RfxSubmissionStatus };

// this is a class type
export { ReturnableScheduleFileUpload };

export const rfxSubmission = {
	api: submissionApi,
	constants: {
		HAS_ACCEPTED,
		HAS_SUBMITTED,
		QUESTION_TYPE: QUESTION_TYPE_ID,
		RFX_SUBMISSION_STATUS,
	},
	helpers: {
		getTextLengthValue,
		isSmartField,
	},
	generateSaveSubmissionPayload,
};
